// extracted by mini-css-extract-plugin
export var backButton = "_12-1";
export var content = "_12-d";
export var continueButton = "_12-7";
export var continueHint = "_12-8";
export var continueRow = "_12-6";
export var leftInner = "_12-0";
export var sidebarContent = "_12-5";
export var skipButton = "_12-c";
export var spacer = "_12-2";
export var spin = "_12-a";
export var spinner = "_12-9";
export var spinnerOverlay = "_12-b";
export var subtitle = "_12-4";
export var title = "_12-3";